import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from '../../services/seo.service';
import { AccessibilityNavComponent } from '../../components/layout/accessability-nav/accessibility-nav.component';
import { NavbarComponent } from '../../components/layout/navbar/navbar.component';
import { FooterComponent } from '../../components/layout/footer/footer.component';
import { ErrorPageComponent } from '../../components/layout/error-page/error-page.component';
import { Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { routes } from '../../constants/routes';

@Component({
  selector: 'no-data-found',
  standalone: true,
  imports: [
    AccessibilityNavComponent,
    NavbarComponent,
    FooterComponent,
    ErrorPageComponent,
    NgIf,
    RouterLink
  ],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.scss',
})
export class NoDataFoundComponent implements OnInit {
  errorMessage = '';
  routes = routes;

  constructor(
    private seoService: SeoService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngOnInit() {
    this.seoService.setPageTitle('No data found');
    this.seoService.setPageDescription('No data found');
    this.seoService.removeAllCanonicalLinks();
    if (isPlatformBrowser(this.platformId)) {
    this.errorMessage =
      history.state?.errorMessage ||
      this.router.getCurrentNavigation()?.extras.state?.['errorMessage'] ||
      'Something went wrong. Please try again later';
    }
  }
}
